module.exports = __webpack_public_path__ + "static/img/A177.c505101c.jpg";